import React from 'react';
import DepositForm from "./DepositForm";
import {typeSF18b, typeSF18r, typeSF32b} from "../../styles/typefaces";
import styled from 'styled-components';
import {Link} from "react-router-dom";
import routes from "../../routes";

const Header = styled.h3`
  ${typeSF32b};
`;

const Subheader = styled.h4`
  ${typeSF18b};
`;

const Brief = styled.div`
  ${typeSF18r};
  p {
    margin-bottom: 1.6em;
  }
`;

const CustomContainer = styled.div`

`;


const DepositSection = ({onComplete, phone, ...props}) => (
  <CustomContainer {...props}>
    <Header>One last thing...</Header>
    <Brief>
      <p>
        Being reliable is one of the most important parts of being a Pro.<br/>
        We've found that Pros who keep a $10 minimum balance on SingleShift are more reliable than those that don't.
      </p>
    </Brief>
    <Subheader>$10 minimum balance</Subheader>
    <Brief>
      <p>
        You can have this transferred back to you at any time. See <Link to={routes.prosFaq}>FAQ</Link> for more
        information.
      </p>
    </Brief>
    <DepositForm phone={phone} onComplete={onComplete}/>
  </CustomContainer>
);

export default DepositSection;


// WEBPACK FOOTER //
// ./src/pages/shift-page/DepositSection.js